module.exports = __webpack_public_path__ + "img/header_bg2.888169a0.png";